import { useState, useContext, useEffect } from "react";
import { AuthContext } from "../../../context/AuthContext";
import { useNavigate } from "react-router-dom";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import {
  Box,
  Button,
  Paper,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  useMediaQuery,
} from "@mui/material";
import useOrdersAdmin from "../../../hooks/useOrdersAdmin";
import ListFooter from "../../../components/InfiniteScroller/ListFooter";
import OrderTableRow from "../Orders/OrderTableRow";
import { useInView } from "react-intersection-observer";
import { useDebounce } from "use-debounce";
import InfiniteScrollerTable from "../../../components/InfiniteScroller/InfiniteScrollerTable";
import { useTheme } from "@emotion/react";
import SearchBar from "../../../components/SearchBar";
import { toTwoDecimals } from "../../../components/NewDetail/calculations/utils";

const CustomerOrders = ({ companyId = null }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const { authToken } = useContext(AuthContext);
  const [
    searchQuery,
    setSearchQuery,
    orders,
    onRefresh,
    refreshing,
    onLoadMore,
    loadingMore,
    total,
    hasMore,
  ] = useOrdersAdmin(authToken, 50, companyId);

  const [ref, inView, entry] = useInView({
    /* Optional options */
    threshold: 0.5, //Number between 0 and 1 indicating the percentage that should be visible before triggering. Can also be an array of numbers, to create multiple trigger points.
  });

  const [inViewDebounce] = useDebounce(inView, 1000);

  useEffect(() => {
    if (orders.length > 0 && inView) {
      console.log("Footer Element In View. Load More...");
      onLoadMore();
    }
  }, [inViewDebounce]);

  return (
    <Box
      sx={{ display: "flex", alignItems: "center", flexDirection: "column" }}
    >
      <SearchBar
        size="large"
        label="Search Orders"
        searchQuery={searchQuery}
        setSearchQuery={setSearchQuery}
      />

      <InfiniteScrollerTable
        TableContainerComponent={Paper}
        TableStyle={{ minWidth: "600px" }}
        TableHead={() => (
          <TableHead>
            <TableRow>
              <TableCell align="left">ID</TableCell>
              <TableCell align="left">Project</TableCell>
              <TableCell align="left">PO #</TableCell>
              <TableCell align="left">Quote Status</TableCell>
              <TableCell align="left">$</TableCell>
            </TableRow>
          </TableHead>
        )}
        items={orders}
        renderRow={(order, index) => {
          return (
            <TableRow
              key={order.id}
              onClick={() => {
                navigate(`/orders/${order.id}`);
              }}
            >
              <TableCell align="left">{order.id}</TableCell>
              <TableCell align="left">{order.project.name}</TableCell>
              <TableCell align="left">
                <Box
                  sx={{
                    // width: "100px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    display: "-webkit-box",
                    WebkitLineClamp: "1",
                    WebkitBoxOrient: "vertical",
                  }}
                >
                  {order.poNumber}
                </Box>
              </TableCell>
              <TableCell align="left">
                <Button
                  size="small"
                  variant="outlined"
                  sx={{ borderRadius: "25px" }}
                  color={
                    order.orderStatus.name == "QUOTE_REQUESTED"
                      ? "warning" // "Draft"
                      : order.orderStatus.name == "ESTIMATE_APPROVAL_NEEDED"
                      ? "info" // "Sent"
                      : order.orderStatus.name == "CANCELLED"
                      ? "error" // "Cancelled"
                      : // All Other Status is "Sold"
                        "success" //"Sold"
                  }
                >
                  {order.orderStatus.name == "QUOTE_REQUESTED"
                    ? `Draft${order.isNewEstimateRequested ? " (RENEW)" : ""}`
                    : order.orderStatus.name == "ESTIMATE_APPROVAL_NEEDED"
                    ? "Sent"
                    : order.orderStatus.name == "CANCELLED"
                    ? "Cancelled"
                    : // All Other Status is "Sold"
                      "Sold"}
                </Button>
              </TableCell>
              <TableCell align="left">
                {order.outTheDoorCost !== undefined &&
                order.outTheDoorCost !== null &&
                order.estimatePdf
                  ? `$${Math.round(Number(order.outTheDoorCost ?? 0))}`
                  : `---`}
              </TableCell>
            </TableRow>
          );
        }}
        onRefresh={onRefresh}
        onEndReached={onLoadMore}
        loading={refreshing || loadingMore}
        ListFooterComponent={() => {
          return <ListFooter hasMore={hasMore} onClick={onLoadMore} />;
        }}
      />
    </Box>
  );
};
export default CustomerOrders;
